var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-nowrap"},[_c('b-badge',{class:_vm.badgeClass,attrs:{"variant":_vm.variant}},[_vm._v(" "+_vm._s(_vm._f("capitalizeFormat")(_vm._f("humanizedFormat")(_vm.status)))+" "),(_vm.subStatus)?_c('span',[_vm._v("- "+_vm._s(_vm._f("capitalizeFormat")(_vm._f("humanizedFormat")(_vm.subStatus))))]):_vm._e()])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }